import React from "react";

const Collaboration = () => {
  return (
    <section id="clients" className="section-padding bg-light">
      <div className="container">
        <div className="collaboration-grid">
          <div className="collaboration-image">
            <img 
              src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzU4MTg4MDE0fDA&ixlib=rb-4.1.0&q=85"
              alt="Diverse team working together"
              className="section-image"
              loading="lazy"
            />
          </div>
          <div className="collaboration-content">
            <h2 className="section-heading">Collaboration that delivers</h2>
            <p className="section-text collaboration-paragraph">
              <strong>Government Departments:</strong> We maintain relationships across major government agencies, providing pathways to stable, long‑term contracts with comprehensive benefits. If the role requires security clearances, we work with authorised DISP‑accredited partners who are able to sponsor eligible candidates for the appropriate clearances.
            </p>
            <p className="section-text collaboration-paragraph">
              <strong>Financial Services Sector:</strong> From big four banks to fintech innovators, we place IT professionals in roles where technology drives business transformation—and compensation reflects that importance.
            </p>
            <p className="section-text collaboration-paragraph">
              <strong>Enterprise & Consulting:</strong> Direct partnerships with organizations that value expertise over cost-cutting, resulting in premium rates and career-building projects.
            </p>
            <div className="collaboration-highlight">
              <h3 className="highlight-title">Why This Matters</h3>
              <p className="highlight-text">
                <strong>These aren't cold-call clients.</strong> They're established relationships built over years, which means when you apply through us, you're not competing with hundreds of other candidates. You're receiving priority consideration through our trusted partnerships.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Collaboration;
